import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HotSection from './components/HotSection';
import TimelineSection from './components/TimelineSection';
import ReviewSection from './components/ReviewSection';
import TopicSection from './components/TopicSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <HotSection />
        <TimelineSection />
        <ReviewSection />
        <TopicSection />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />

      {showTop && (
        <a
          href="#top"
          aria-label="回到顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
        </a>
      )}
    </div>
  );
}